export enum Experiment {
  EditorOOI = 'specs.loyalty.EditorOOI',
  CheckoutMonetaryEarnValue = 'specs.loyalty.CheckoutMonetaryEarnValue',
  HeaderImageAltText = 'specs.loyalty.HeaderImageAltText',
}
